import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { GetExecutor, GetAllBeneficiary } from "../../api/get";
import Modal from "react-responsive-modal";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { useFormik } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import { FaAngleLeft } from "react-icons/fa6";
import Spinner from "../../Common/Spinner";
import { FaChevronRight } from "react-icons/fa";

import {
  AddBeneficiary,
  SaveEstateBeneficiary,
  SaveExecutor,
} from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../loader";
import Header from "../../Common/Header";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { FaInfoCircle } from "react-icons/fa";
import { handleApiError } from "../../Common/Helper";

const Estate = () => {
  const [refresh, setRefresh] = useState(false);
  const [beneficiaries, setBeneficiary] = useState([]);

  const [openModal, setOpenModal] = useState();
  const [contentLoder, setContentLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/mm/yyyy");
  const [isFocused, setIsFocused] = useState(false);
  const onCloseModel = () => {
    setOpenModal(false);
    formikAddBeneficiary.resetForm(); // Reset the form on modal close
  };
  const formatDateToYMD = (dob) => {
    if (!dob || dob === "undefined" || dob.trim() === "") {
      return ""; // Return an empty string if the input is invalid
    }
    // Assuming `dob` is in "dd/mm/yyyy" format
    const [day, month, year] = dob.split("/");
    if (!day || !month || !year) {
      return ""; // Return empty if any part is missing
    }
    return `${year}-${month}-${day}`; // Convert to "yyyy-mm-dd"
  };
  useEffect(() => {
    setContentLoader(true);
    GetAllBeneficiary()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setBeneficiary(res.data);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate); // Use helper function
        }
      })
      .catch((err) => {
        setContentLoader(false);
        console.log(err);
      });
  }, [refresh]);
  console.log("beneficiaries =>", beneficiaries);

  const formik = useFormik({
    initialValues: {
      beneficiaries:
        beneficiaries.length > 0
          ? beneficiaries.map((b) => ({
              id: b.id || null,
              beneficiary_type: b.beneficiary_type,
              isSelected: b.is_selected || false,
            }))
          : [], // Handle empty state
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      beneficiaries: Yup.array().of(
        Yup.object({
          id: Yup.number().nullable(),
          isSelected: Yup.boolean(),
        })
      ),
    }),
    onSubmit: async (values) => {
      console.log("values =>", values);
      try {
        const beneficiaries_ids = values.beneficiaries
          .filter((beneficiary) => beneficiary.isSelected)
          .map((beneficiary) => beneficiary.id);

        const payload = { beneficiaries_ids };
        console.log("payload =>", payload);
        SaveEstateBeneficiary(payload)
          .then((res) => {
            if (res.success && res.status_code === "200") {
              // toast.success("Beneficiary Save Successfully");
              navigate("/make-will-online/estate/charity/standard");
            } else {
             handleApiError(res,navigate);
            }
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            toast.error("An error occurred");
            console.log(err);
          });
      } catch (error) {
        console.error("API Error:", error);
      }
    },
  });
  const validationSchemaForbeneficiary = Yup.object().shape({
    beneficiary_first_name: Yup.string().required("Required field"),
    beneficiary_last_name: Yup.string().required("Required field"),
    beneficiary_email: Yup.string().email("Invalid email address"),
    beneficiary_dob: Yup.string()
      .nullable()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
        "Date of birth must be in dd/mm/yyyy format"
      )
      .test("is-past-date", "Date must be in the past", (value) => {
        if (!value) return true; // Skip if empty
        const [day, month, year] = value.split("/");
        const enteredDate = new Date(`${year}-${month}-${day}`);
        return enteredDate < new Date();
      })
      .test(
        "is-after-1900",
        "Please enter a date of birth after 1900",
        (value) => {
          if (!value) return true; // Skip if empty
          const [day, month, year] = value.split("/");
          return parseInt(year) > 1900;
        }
      ),
  });
  const formikAddBeneficiary = useFormik({
    initialValues: {
      beneficiary_first_name: "",
      beneficiary_last_name: "",
      beneficiary_email: "",
      beneficiary_dob: "",
      beneficiary_location: "",
      beneficiary_live_at_my_address: "",
    },
    validationSchema: validationSchemaForbeneficiary, // Apply validation schema
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      // Convert "date_of_birth" from "dd/mm/yyyy" to "dob" with "dd-mm-yyyy"
      const transformedValues = {
        ...values,
        beneficiary_dob: values.beneficiary_dob
          ? formatDateToYMD(values.beneficiary_dob)
          : "", // Handle empty or invalid input
      };
      // setRefreshBenficiary(false);
      values.beneficiary_live_at_my_address =
        values.beneficiary_live_at_my_address ? 1 : 0;
      console.log("transformedValues  =>", transformedValues);

      AddBeneficiary(transformedValues)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            const newBeneficiary = res.data;
            var data = {
              id: newBeneficiary.id,
              beneficiary_first_name: newBeneficiary.beneficiary_first_name,
              beneficiary_last_name: newBeneficiary.beneficiary_last_name,
              beneficiary_dob: newBeneficiary.beneficiary_dob,
              beneficiary_type: "other",
              is_selected: true,
            };
            // Append new beneficiary to the list
            setBeneficiary((prev) => [...prev, data]);
            // Update Formik values
            formik.setFieldValue("beneficiaries", [
              ...formik.values.beneficiaries,
              {
                id: newBeneficiary.id,
                isSelected: false, // Default value for isSelected
                ...newBeneficiary, // Add other returned data
              },
            ]);
            toast.success("Beneficiary Added Successfully");
            setOpenModal(false);
            resetForm(); // This will clear the form fields
          } else {
             handleApiError(res,navigate);
          }
        })
        .catch((err) => {
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  return (
    <>
      {contentLoder ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container">
            <div className="grid grid-cols-2 max-lg:grid-cols-1 mt-[30px]">
              <form onSubmit={formik.handleSubmit}>
                <div>
                  <p className="text-[26px] font-semibold">
                    Divide your estate
                  </p>
                  <p className="my-3 text-slate-500">
                    Your estate is made up of everything you own. It includes
                    bank accounts, your home, stocks and shares, ISAs and any
                    personal belongings.
                  </p>
                  <p className="my-3 text-slate-500">
                    Firstly, choose the people you want to share your estate.
                    You will then give a percentage to each person and decide
                    who you want their ‘back-up’ beneficiary to be, if they die
                    before you.
                  </p>
                  <p className="my-3 text-slate-500">
                    Once you’ve divided your estate, we’ll move on to specific
                    gifts of money or items to others.
                  </p>
                  <h4 className="text-[22px] font-bold mt-3">
                    Who would you like to share your estate?
                  </h4>
                  <p className="text-slate-500">
                    Tick to select someone as a beneficiary.
                  </p>

                  {beneficiaries.map((beneficiary, index) => (
                    <div
                      className={`my-5 border-2 pb-3 px-4 GuardianDiv rounded ${
                        formik.values.beneficiaries[index]?.isSelected
                          ? "blueBorder"
                          : `border-[#d7d7d7] `
                      } 
                    `}
                      onClick={() => {
                        setBeneficiary((prevList) =>
                          prevList.map((beneficiary, idx) =>
                            idx === index
                              ? {
                                  ...beneficiary,
                                  is_selected: !beneficiary.is_selected,
                                }
                              : beneficiary
                          )
                        );
                        formik.setFieldValue(
                          `beneficiaries[${index}].isSelected`,
                          !formik.values.beneficiaries[index]?.isSelected
                        );
                      }}
                      key={beneficiary.id || index}
                    >
                      <div className="border-[#d7d7d7] rounded-lg">
                        <div className="flex items-center justify-between mt-[16px]">
                          <div className="flex items-center gap-5">
                            <div>
                              <img src="/assets/images/icon-mascot.png" />
                            </div>
                            <div>
                              <h4 className="text-[20px] text-black font-bold">
                                {beneficiary?.beneficiary_first_name}{" "}
                                {beneficiary?.beneficiary_last_name}
                              </h4>
                              <p>Your {beneficiary?.beneficiary_type}</p>
                            </div>
                          </div>
                          <div>
                            <input
                              name={`beneficiaries[${index}].isSelected`}
                              type="checkbox"
                              className={`w-[20px] h-[20px]  ${
                                !beneficiary.is_selected
                                  ? "opacity-50 cursor-not-allowed"
                                  : ""
                              }`}
                              checked={
                                formik.values.beneficiaries[index]
                                  ?.isSelected || false
                              }
                              onChange={(e) => {
                                // e.stopPropagation(); // Prevent the parent div's onClick from firing
                                formik.setFieldValue(
                                  `beneficiaries[${index}].isSelected`,
                                  e.target.checked
                                );
                              }}
                              // disabled={
                              //   addButtonDisable && !beneficiary.is_selected
                              // }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="my-5 border-b-2 pb-5">
                    <div className="border-[#d7d7d7] rounded-lg border-2 pb-3 px-4 ">
                      <div className="flex items-center justify-between mt-[16px]">
                        <div className="flex items-center gap-5">
                          <div>
                            <img src="/assets/images/icon-mascot.png" />
                          </div>
                          <div>
                            <h4 className="text-[16px] text-black font-muli font-bold ">
                              Add a new beneficiary
                            </h4>
                            <p>Leave your estate to someone else</p>
                          </div>
                        </div>
                        <div>
                          <Link>
                            <button
                              onClick={() => setOpenModal(true)}
                              className="border-2 rounded-[5px] border-[#240642] text-[#240642] px-4 py-1 font-bold"
                            >
                              Add
                            </button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between mb-5">
                    <Link to={"/dashboard"}>
                      <button
                        type="button"
                        className="flex items-center justify-center gap-1 text-[20px] py-2 rounded-[10px] text-slate-500"
                      >
                        <FaAngleLeft />
                        Back
                      </button>
                    </Link>
                    <button
                      type="submit"
                      className="bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex items-center gap-2"
                      onClick={() => {
                        setLoading(true);
                      }}
                    >
                      {loading ? <Spinner /> : "Next"}{" "}
                      {!loading ? <FaChevronRight /> : ""}
                    </button>
                  </div>
                </div>
              </form>
              <div>
                <div className=" bg-no-repeat max-lg:hidden">
                  <div className="fixed top-[100px] w-[500px] right-[6%]">
                    <img src="/assets/images/9.png" alt="mascot" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            open={openModal}
            onClose={onCloseModel}
            center
            classNames={{
              modal: "rounded-[5px] p-5", // Add the rounded class here along with padding
            }}
          >
            <div className="px-5">
              <form onSubmit={formikAddBeneficiary.handleSubmit}>
                <div>
                  <div>
                    <h4 className="text-[26px] text-black font-bold mt-[10px]">
                      Add someone new
                    </h4>
                    <p className="mt-2">
                      You can leave money or personal belongings to them
                    </p>
                  </div>
                  <div className="grid grid-cols-2 gap-5 ">
                    <div className="mt-5 mb-4 ">
                      <FloatingLabelInput
                        label="First Name"
                        type="text"
                        id="first_name"
                        name="beneficiary_first_name"
                        value={
                          formikAddBeneficiary.values.beneficiary_first_name
                        }
                        onChange={formikAddBeneficiary.handleChange}
                        onBlur={formikAddBeneficiary.handleBlur}
                        error={
                          formikAddBeneficiary.touched.beneficiary_first_name &&
                          formikAddBeneficiary.errors.beneficiary_first_name
                        }
                      />
                    </div>

                    <div className="mt-5 mb-4 ">
                      <FloatingLabelInput
                        label="Last Name"
                        type="text"
                        id="last_name"
                        name="beneficiary_last_name"
                        value={
                          formikAddBeneficiary.values.beneficiary_last_name
                        }
                        onChange={formikAddBeneficiary.handleChange}
                        onBlur={formikAddBeneficiary.handleBlur}
                        error={
                          formikAddBeneficiary.touched.beneficiary_last_name &&
                          formikAddBeneficiary.errors.beneficiary_last_name
                        }
                      />
                    </div>
                  </div>
                  <div className="mt-1 mb-4 ">
                    <FloatingLabelInput
                      label="Email address (optional)"
                      type="text"
                      id="new_guardian_email"
                      name="beneficiary_email"
                      value={formikAddBeneficiary.values.beneficiary_email}
                      onChange={formikAddBeneficiary.handleChange}
                      onBlur={formikAddBeneficiary.handleBlur}
                      error={
                        formikAddBeneficiary.touched.beneficiary_email &&
                        formikAddBeneficiary.errors.beneficiary_email
                      }
                    />
                  </div>
                  <div className="w-full mt-5">
                    <div className="relative w-full border-2 h-[60px] flex items-center">
                      <MaskedInput
                        mask={[
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          "/",
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        placeholder={
                          isFocused ||
                          formikAddBeneficiary.values.beneficiary_dob
                            ? "dd/mm/yyyy"
                            : ""
                        }
                        pipe={autoCorrectedDatePipe}
                        value={formikAddBeneficiary.values.beneficiary_dob}
                        onFocus={() => setIsFocused(true)}
                        onBlur={(e) => {
                          setIsFocused(false);
                          formikAddBeneficiary.handleBlur(e); // To ensure Formik registers field as "touched"
                        }}
                        onChange={(e) => {
                          formikAddBeneficiary.setFieldValue(
                            "beneficiary_dob",
                            e.target.value
                          );
                        }}
                        className="block text-black w-full px-[20px] h-full appearance-none focus:outline-none focus:ring-0 peer border-red-500 focus:border-red-500"
                        name="beneficiary_dob"
                      />

                      <label
                        htmlFor="dob"
                        className="absolute left-5 top-[16px]  text-gray-500 transition-all duration-200 transform text-[10px] -translate-y-3.5 peer-placeholder-shown:text-[16px] peer-placeholder-shown:translate-y-0 peer-focus:text-[10px] peer-focus:-translate-y-3.5"
                      >
                        Date of birth(optional)
                      </label>
                    </div>
                  </div>
                  {formikAddBeneficiary.touched.beneficiary_dob &&
                  formikAddBeneficiary.errors.beneficiary_dob ? (
                    <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                      <FaInfoCircle />
                      <p className="text-white py-1 px-2 text-sm my-2">
                        {formikAddBeneficiary.errors.beneficiary_dob}
                      </p>
                    </div>
                  ) : null}

                  <div>
                    <h4 className="text-[16px] text-black font-bold mt-[36px]">
                      Add their address
                    </h4>
                    <p className="text-slate-500 my-2">
                      Adding address is optional
                    </p>
                  </div>
                  <div className="mt-1 mb-4 ">
                    <FloatingLabelInput
                      label="Enter their full address"
                      type="text"
                      id="beneficiary_location"
                      name="beneficiary_location"
                      value={formikAddBeneficiary.values.beneficiary_location}
                      onChange={formikAddBeneficiary.handleChange}
                      onBlur={formikAddBeneficiary.handleBlur}
                    />
                  </div>
                  <div className="mt-5">
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        className="form-checkbox h-5 w-5 text-indigo-600 transition duration-150 ease-in-out"
                        checked={
                          formikAddBeneficiary.values
                            .beneficiary_live_at_my_address
                        }
                        onChange={() =>
                          formikAddBeneficiary.setFieldValue(
                            "beneficiary_live_at_my_address",
                            !formikAddBeneficiary.values
                              .beneficiary_live_at_my_address
                          )
                        }
                      />
                      <span className="ml-2 text-gray-700">
                        They live at my address?
                      </span>
                    </label>
                  </div>
                  <div className="flex justify-between">
                    <div className="py-5 ">
                      <button
                        type="submit"
                        className="px-5 py-3 mt-3 text-white font-bold bg-primary rounded flex items-center gap-1"
                      >
                        Add this person
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default Estate;
